import { Icon } from "../../styles/icons";

export const NewActivityIndicator = () => {
  return (
    <div className="rsvp-label new-activity-label-blue">
      <p className="rsvp-label-text">New</p>
    </div>
  );
};
